import { LOADING_COLLECTIONS } from "../actions/actionTypes";

// const initialState = [];
const initialState = {
	collections: [],
	loading: false
}

export default function collectionReducer(state = initialState, action) {
	const { type, payload } = action;

	// switch (type) {
	//     case value:
	//         break;

	//     default:
	//         break;
	// }
	switch (type){
		case LOADING_COLLECTIONS:
			return {
				...state,
				loading: payload
			};

		default:
			return state;
	}
}
